import React, { useState, useEffect } from 'react';
import { Card, CardBody } from './../card/card.jsx';

function ThemePanel() {
  const getLS = (key, fallback) =>
    (localStorage && typeof localStorage[key] !== 'undefined'
      ? localStorage[key]
      : fallback);

  const [active, setActive] = useState(0);
  const [mode, setMode] = useState(getLS('appMode', 'light'));
  const [theme, setTheme] = useState(getLS('appTheme', 'theme-gray-800'));
  const [cover, setCover] = useState(getLS('appCover', ''));
  const darkThemes = ['theme-black'];

  useEffect(() => {
  const transparentCoverClass = 'bg-cover-8';
  document.documentElement.classList.remove('no-bg-cover');
  document.documentElement.classList.add(transparentCoverClass);
  if (localStorage) localStorage.appCover = transparentCoverClass;
  setCover(transparentCoverClass);
}, []);

  const toggleAppThemePanel = (event) => {
    event.preventDefault();
    setActive((prev) => (prev === 0 ? 1 : 0));
  };

  const clearBackground = () => {
    document.documentElement.className = document.documentElement.className
      .split(' ')
      .filter((c) => !c.startsWith('bg-cover-') && c !== 'no-bg-cover')
      .join(' ');
    document.body.style.background = 'none';
    document.documentElement.style.background = 'none';
  };

const setAppTheme = (event, themeValue) => {
  event.preventDefault();

  // Remove old theme-* classes
  document.body.className = document.body.className
    .split(' ')
    .filter(c => !c.startsWith('theme-'))
    .join(' ');

  if (themeValue) {
    document.body.classList.add(themeValue);
  }

  // Save theme
  if (localStorage) localStorage.appTheme = themeValue;
  setTheme(themeValue);

  // If theme is dark-only
  if (darkThemes.includes(themeValue)) {
    // Force dark mode
    document.documentElement.setAttribute('data-bs-theme', 'dark');
    if (localStorage) localStorage.appMode = 'dark';
    setMode('dark');

    // Disable Light mode button
    const lightBtn = document.querySelector('#mode-light');
    if (lightBtn) {
      lightBtn.setAttribute('disabled', true);
      lightBtn.classList.add('disabled'); // optional styling
    }
  } else {
    // Re-enable Light mode button
    const lightBtn = document.querySelector('#mode-light');
    if (lightBtn) {
      lightBtn.removeAttribute('disabled');
      lightBtn.classList.remove('disabled');
    }
  }

  document.dispatchEvent(new Event('theme-reload'));
};

// Extra safety: block mode changes to light if black theme is active
const setAppMode = (event, modeValue) => {
  event.preventDefault();

  const currentTheme = localStorage?.appTheme || '';
  // if (darkThemes.includes(currentTheme) && modeValue === 'light') {
  //   console.warn('Light mode is not allowed for Black theme.');
  //   return; // block the change
  // }

   // If trying to go light while on a dark-only theme, switch theme first
 if (darkThemes.includes(currentTheme) && modeValue === 'light') {
   // pick your default light‑friendly theme
   const fallbackTheme = 'theme-gray-800';
   document.body.className = document.body.className
     .split(' ')
     .filter(c => !c.startsWith('theme-'))
     .join(' ');
   document.body.classList.add(fallbackTheme);
   if (localStorage) localStorage.appTheme = fallbackTheme;
   setTheme(fallbackTheme);
 }

  document.documentElement.setAttribute('data-bs-theme', modeValue);
  if (localStorage) localStorage.appMode = modeValue;
  setMode(modeValue);
};



  const setAppCover = (event, coverClass) => {
    event.preventDefault();
    clearBackground();

    if (coverClass) {
      document.documentElement.classList.add(coverClass);
      document.documentElement.classList.remove('no-bg-cover');
      if (localStorage) localStorage.appCover = coverClass;
    } else {
      document.documentElement.classList.add('no-bg-cover');
      if (localStorage) localStorage.appCover = '';
    }

    setCover(coverClass);
  };

  const modeList = [
    { name: 'Dark', img: '/assets/img/mode/dark.jpg', value: 'dark' },
    { name: 'Default', img: '/assets/img/mode/light.jpg', value: 'light' },
    // { name: 'Black', img: '/assets/img/mode/black.jpg', value: 'dark' }
  ];

  const themeList = [
    { name: 'Teal', bgClass: 'bg-teal', themeClass: 'theme-teal' },
    { name: 'Dark Gray', bgClass: 'bg-gray-800', themeClass: 'theme-gray-800' },
    { name: 'Black', bgClass: 'bg-gray-200', themeClass: 'theme-black' }
  ];

  const coverList = [
    // {
    //   name: 'No Background',
    //   coverThumbImage: '/assets/img/cover/transparent.png',
    //   coverClass: ''
    // },
    {
      name: 'Default',
      coverThumbImage: '/assets/img/cover/transparent.png',
      coverClass: 'bg-cover-8'
    }
  ];

  return (
    <div className={'app-theme-panel' + (active ? ' active' : '')}>
      <div className="app-theme-panel-container">
        <a href="#/" onClick={toggleAppThemePanel} className="app-theme-toggle-btn">
          <i className="bi bi-sliders"></i>
        </a>
        <div className="app-theme-panel-content">
          <div className="small fw-bold text-inverse mb-1">Display Mode</div>
          <Card className="mb-3">
            <CardBody className="p-2">
              <div className="row gx-2">
                {modeList.map((m, index) => (
                  <div className="col-6" key={index}>
                    <a
                      href="#/"
                      onClick={(event) => setAppMode(event, m.value)}
                      className={'app-theme-mode-link ' + (mode === m.value ? 'active' : '')}
                    >
                      <div className="img">
                        <img src={m.img} className="object-fit-cover" height="76" width="76" alt="" />
                      </div>
                      <div className="text">{m.name}</div>
                    </a>
                  </div>
                ))}
              </div>
            </CardBody>
          </Card>

          <div className="small fw-bold text-inverse mb-1">Theme Color</div>
          <Card className="mb-3">
            <CardBody className="p-2">
              <div className="app-theme-list">
                {themeList.map((t, index) => (
                  <div
                    className={'app-theme-list-item ' + (theme === t.themeClass ? 'active' : '')}
                    key={index}
                  >
                    <a
                      href="#/"
                      onClick={(event) => setAppTheme(event, t.themeClass)}
                      className={'app-theme-list-link ' + t.bgClass}
                      data-bs-toggle="tooltip"
                      data-bs-trigger="hover"
                      data-bs-container="body"
                    >
                      &nbsp;
                    </a>
                  </div>
                ))}
              </div>
            </CardBody>
          </Card>

          <div className="small fw-bold text-inverse mb-1">Theme Cover</div>
          <Card>
            <CardBody className="p-2">
              <div className="app-theme-cover">
                {coverList.map((c, index) => (
                  <div className={'app-theme-cover-item ' + (cover === c.coverClass ? 'active' : '')} key={index}>
                    <a
                      href="#/"
                      onClick={(event) => setAppCover(event, c.coverClass || null)}
                      className="app-theme-cover-link"
                      style={{ backgroundImage: `url(${c.coverThumbImage})` }}
                      data-cover-class={c.coverClass}
                      data-bs-toggle="tooltip"
                      data-bs-trigger="hover"
                      data-bs-container="body"
                    >
                      {c.name === 'No Background' && (
                        <span style={{
                          position: 'absolute',
                          top: 0, left: 0, right: 0, bottom: 0,
                          background: 'rgba(255,255,255,0.85)',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          fontWeight: 'bold',
                          fontSize: '12px',
                          color: '#444'
                        }}>No BG</span>
                      )}
                    </a>
                  </div>
                ))}
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default ThemePanel;
